import {userService} from '../_services'
import {router} from '../router'

const user = JSON.parse(localStorage.getItem('user'))
const initialState = user
    ? { status: { loggedIn: true }, user }
    : { status: {}, user: null }


const links = {'psychologists':'ReportPsychForm',
  'outreaches':'ReportOutreachForm',
  'lawyers':'ReportLawyerForm',
  'casemanagements':'ReportCaseForm',
  'seminars':'ReportSeminars'
}

export const authentication = {
    namespaced: true,
    state: initialState,
    actions: {
        login ({ dispatch, commit }, { username, password }) {
            commit('loginRequest', { username })
            userService.login(username, password)
                .then(
                    user => {
                        commit('loginSuccess', user)
                        let linkName = 'ReportOutreachList'
                        if (links[user.roles[0].rights])
                            linkName = links[user.roles[0].rights]
                        router.push({name: linkName, params: {reportId: 'new'}})
                        // router.push('/'+link)
                    },
                    error => {
                        commit('loginFailure', error)
                        dispatch('alert/error', error, {root: true})
                    }
                )
        },
        resetPwd ({ dispatch, commit }, { password, token }) {
            // commit('resetPwd', { username, token })

            userService.resetPwd(password, token)
                .then(
                    user => {
                        commit('resetSuccess', user)
                        router.push('/login')
                        dispatch('alert/error', 'Неверные имя пользователя или пароль', {root: true})
                    },
                    error => {
                        commit('resetFailure', error)
                        dispatch('alert/error', 'Не удалось обновить пароль', {root: true})
                    }
                )
        },
        googleLogin ({ dispatch, commit }, { username, avatar}) {
            commit('loginRequest', { username })
            userService.googleLogin(username, avatar)
                .then(
                    user => {
                        commit('loginSuccess', user)
                        let linkName = 'ReportOutreachList'
                        if (links[user.roles[0].rights])
                            linkName = links[user.roles[0].rights]
                        router.push({name: linkName, params: {reportId: 'new'}})
                    },
                    error => {
                      commit('loginFailure', error)
                      dispatch('alert/error', 'Неверные учетные данные', {root: true})
                    }
                )
        },
        logout ({ commit }) {
            userService.logout()
            commit('logout')
        }
    },
    mutations: {
        loginRequest (state, user) {
            state.status = { loggingIn: true }
            state.user = user
        },
        loginSuccess (state, user) {
            state.status = { loggedIn: true }
            state.user = user
        },
        loginFailure (state) {
            state.status = { loggingIn: false }
            state.user = null
        },
        logout (state) {
            state.status = {}
            state.user = null
        },

    }
}



// WEBPACK FOOTER //
// ./src/store/authentication.module.js